import React, { useState, useEffect } from "react";
import WarningModal from "../components-modals/WarningModal";
import Layout from "../Layout";
import Container from "../components-layout/Container";
import Header from "../components-layout/Header";
import {
  CheckCircleIcon,
  ExclamationCircleIcon,
  AcademicCapIcon,
  ArrowUpTrayIcon,
} from "@heroicons/react/24/outline";
import { useSelector } from "react-redux";
import Cookies from "universal-cookie";
import InputFile from "./components/InputFile";
import CirculosBancos from "./components/CirculosBancos";
import { CustomDataGrid } from "../diplomado-plan4/components";
import { fetchApi } from "../tools";

const ContabilidadArchivo = () => {
  const [modal, setModal] = useState({});
  const user = useSelector((state) => state.auth.user);
  const userObj = JSON.parse(user);
  const cookies = new Cookies();
  const url = cookies.get("__urlSchoolApi"); // url para enviar al api viene de cookies
  const url2 = cookies.get("__urlInvoiceApi"); // url para enviar al api viene de cookies
  //const urlCursos = cookies.get("__urlCursosApi"); // url para enviar al api viene de cookies
  const urlSeguridadApi = cookies.get("__urlSeguridad");
  const { headersAPI: headers } = useSelector((state) => state.url); // Headers para enviar al api viene de redux
  const IdEmp = useSelector((state) => state.auth.IdEmp);
  const [showModalConfig, setShowModalConfig] = useState(false);
  const [tituloMenu, setTituloMenu] = useState();

  const columnasNormal = [
    { name: "Nombre", id: 0, type: "text", resaltado: false },
    { name: "Acceso", id: 3, type: "swicht", resaltado: false },
    {
      name: "Submenú",
      id: 999,
      type: "text",
      resaltado: false,
      text: "Permisos",
      alt: "Seleccionar",
    },
  ];

  const handleCancelarSubmenu = () => {};

  const guardarSubmenu = () => {};

  return (
    <>
      <WarningModal
        width={
          showModalConfig
            ? "xl:w-[50%] justify-center flex flex-col shadow-sm shadow-white"
            : "sm:w-full sm:max-w-sm"
        }
        open={modal.show ? true : false}
        image={
          modal.ok ? (
            !showModalConfig ? (
              <CheckCircleIcon className="h-20 w-20 text-green-500 mx-auto" />
            ) : null
          ) : !showModalConfig ? (
            <ExclamationCircleIcon className="h-20 w-20 text-red-500 mx-auto" />
          ) : null
        }
        title={showModalConfig ? "Permisos de " + tituloMenu : "Aviso"}
        subtitle={<span>{modal.msg}</span>}
        opacity="bg-opacity-50"
      >
        {!showModalConfig ? (
          <div className="mt-5 sm:mt-6">
            <button
              onClick={() => {
                if (modal.reload) {
                  window.location.reload();
                }
                setModal((curr) => ({
                  ...curr,
                  show: false,
                  reload: false,
                }));
              }}
              type="button"
              className="inline-flex w-full justify-center rounded-md border border-transparent bg-azulBrillanteMira px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-secundario transition duration-500 ease focus:outline-none sm:text-sm"
            >
              Entendido
            </button>{" "}
          </div>
        ) : (
          <div className="flex w-full justify-center flex-col">
            <div className="flex flex-row justify-between">
              <button
                onClick={() => {
                  handleCancelarSubmenu();
                  if (modal.reload) {
                    window.location.reload();
                  }
                  setModal((curr) => ({
                    ...curr,
                    show: false,
                    reload: false,
                  }));
                }}
                type="button"
                className=" inline justify-center rounded-md border border-transparent bg-azulBrillanteMira px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-secundario transition duration-500 ease focus:outline-none sm:text-sm"
              >
                Cancelar
              </button>{" "}
              <button
                onClick={() => guardarSubmenu()}
                type="button"
                className="inline justify-center rounded-md border border-transparent bg-azulBrillanteMira px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-secundario transition duration-500 ease focus:outline-none sm:text-sm"
              >
                Conservar cambios
              </button>{" "}
            </div>
          </div>
        )}
      </WarningModal>
      <Layout userObj={userObj} activeTab="Subir archivo">
        <Container height="h-full">
          <Header title="Subir archivo" logo={ArrowUpTrayIcon} />
          <div className="w-full flex self-center  justify-center flex-row ">
            <div className="w-full xl:w-[70%] rounded-md shadow-white shadow-sm p-2">
              <CirculosBancos />
              <InputFile />
            </div>
          </div>
        </Container>
      </Layout>
    </>
  );
};

export default ContabilidadArchivo;
